import Component from "vue-class-component";
import { EventBus } from "../Controls/EventBus";
import { VueBase } from "../Controls/VueBase";
import { Location } from "vue-router/types/router";
import EventConstants, { RoleConstants } from "../Controls/EventConstants";
import { ParametresInstance } from "../Controls/Parameters";

@Component({
	components: {
		CommonSalarieComponent: require("./common/commonSalarie.vue.html"),
		IdentiteSalarieComponent: require("./identite/identiteSalarie.vue.html"),
		DeclarationsSalarieComponent: require("./declarations/declarationsSalarie.vue.html"),
		BlocnoteSalarieComponent: require("./blocnote/blocnote.vue.html"),
		ContratSalarieComponent: require("./contratSalarie/contratSalarie.vue.html"),
		QualificationsSalarieComponent: require("./qualifications/qualificationsSalarie.vue.html"),
		CompetencesSalarieComponent: require("./competences/competences.vue.html"),
		ReglementSalarieComponent: require("./reglement/reglement.vue.html"),
		BulletinsSalarieComponent: require("./bulletins/bulletins.vue.html"),
		AbsencesSalarieComponent: require("./absences/absences.vue.html"),
		DocumentsSalarieComponent: require("./documents/documents.vue.html"),
		SalarieLightComponent: require("./salarieLight/salarieLight.vue.html")
	},
	beforeRouteEnter(to, from, next) {
		if (Number(to.params.id) == 0 && !ParametresInstance.userIsAuthorized([RoleConstants.Administrateur, RoleConstants.AdministrateurPST, RoleConstants.Payeur])) {
			next(false);
			return;
		}

		next(v => {
			const vm = (v as SalarieComponent);

			vm.initialize();
			if (to.query.onglet != undefined) {
				vm.tab = Number(to.query.onglet);
				delete to.query.onglet;
			}
		});
	},
	beforeRouteUpdate(to, from, next) {
		if (Number(to.params.id) == 0 && !ParametresInstance.userIsAuthorized([RoleConstants.Administrateur, RoleConstants.AdministrateurPST, RoleConstants.Payeur])) {
			next(false);
			return;
		}

		next();

		const vm = (this as SalarieComponent);
		vm.initialize();

		if (to.query.onglet != undefined) {
			vm.tab = Number(to.query.onglet);
			delete to.query.onglet;
		}
	},
	beforeRouteLeave(to, from, next) {
		const _this = (this as SalarieComponent);
		_this.saveState(_this.currentId);
		next();
	}
})
export default class SalarieComponent extends VueBase {
	public tab = 1;
	public salarieCharges: salarieChargeInfos[] = [];
	public listIdCharges: number[] = [];
	public currentId = -1;
	public counterNotes = 0;
	public paieEnable = false;
	public componentKey = 0;

	public mounted(): void {
		EventBus.$on(EventConstants.SOCIETE_CHANGED, () => {
			this.paieEnable = (ParametresInstance.societeCourante != undefined && ParametresInstance.societeCourante.IsPaieActive) || ParametresInstance.userIsAuthorized([RoleConstants.Administrateur]);
		});

		const id = Number(this.$route.params.id);
		EventBus.$once(EventConstants.ALL_LISTES_LOADED, () => {
			this.reloadData(id);
		});

		this.paieEnable = (ParametresInstance.societeCourante != undefined && ParametresInstance.societeCourante.IsPaieActive) || ParametresInstance.userIsAuthorized([RoleConstants.Administrateur]);
	}

	/**
	 * Initialisation de la page
	 */
	public initialize(): void {
		if (ParametresInstance.checkListLoaded()) {
			this.reloadData(Number(this.$route.params.id));
		}
	}

	/**
	 * Recharge les données du salarié
	 * @param id
	 */
	public reloadData(id: number): void {
		if (this.currentId > 0) {
			this.saveState(this.currentId);
		}
		this.currentId = id;

		// Si le salarié est déjà chargé, on le recharge
		if (this.salarieCharges[this.currentId] != undefined) {
			this.tab = this.salarieCharges[this.currentId].tab;
			this.isModified = this.salarieCharges[this.currentId].isModified;
		} else { // sinon on set les valeurs par défaut
			this.tab = 1;
			this.isModified = false;
			this.saveState(this.currentId);
		}

		this.$children.forEach(c => {
			const child: any = c;

			if (child.reloadData != undefined) {
				child.reloadData(id);
			}
		});
	}

	public saveState(id: number): void {
		if (id == -1) {
			return;
		}

		const existingSalarie = this.salarieCharges[id];
		const route = existingSalarie != undefined ? existingSalarie.route : this.$router.currentRoute.path;

		this.salarieCharges[id] = {
			route: route,
			tab: this.tab,
			isModified: this.isModified
		};

		if (this.listIdCharges.filter(n => n == id).length == 0) {
			this.listIdCharges.push(id);
		}
	}

	public checkIsModified(location: Location): boolean {
		for (let i = 0; i < this.listIdCharges.length; i++) {
			if (this.salarieCharges[this.listIdCharges[i]] != undefined) {
				if (this.salarieCharges[this.listIdCharges[i]].route == location.path) {
					return this.salarieCharges[this.listIdCharges[i]].isModified;
				}
			} else {
				console.warn("La liste des salariés chargés ne contient pas la clé " + this.listIdCharges[i]);
			}
		}

		return false;
	}

	public closing(location: Location): void {
		if (location != undefined && location.path != undefined) {
			super.closing(location);
		}

		for (let i = 0; i < this.listIdCharges.length; i++) {
			const idToClose = this.listIdCharges[i];

			if (this.salarieCharges[idToClose] != undefined) {
				if (this.salarieCharges[idToClose].route == location.path) {
					if (this.currentId == idToClose) {
						this.tab = 1;
						this.isModified = false;
					}

					this.$children.forEach(c => {
						const child: any = c;
						if (child.resetData != undefined) {
							child.resetData(idToClose);
						}
					});

					this.salarieCharges[idToClose].tab = 1;
					this.salarieCharges[idToClose].isModified = false;

					EventBus.$emit("closeTab", { route: location.path });
				}
			} else {
				console.warn("La liste des salariés chargés ne contient pas la clé " + idToClose);
			}
		}

		this.salarieCharges.splice(this.currentId, 1);
	}

	public changeTab(index: any): void {
		if (this.isModified) {
			return;
		}
		this.tab = index;
	}

	public onCurentTabModifier(isModified: any): void {
		this.isModified = isModified;
		this.saveState(this.currentId);
	}

	public estModifiee(index: any): boolean {
		return this.isModified && this.tab == index;
	}

	public identiteUpdated(): void {
		this.$children.forEach(c => {
			const child: any = c;
			if (child.refresh != undefined) {
				child.refresh();
			}
		});
	}

	public contratUpdated(): void {
		this.$children.forEach(c => {
			const child: any = c;
			if (child.refreshQualification != undefined) {
				child.refreshQualification();
			}
			if (child.refreshAbsence != undefined) {
				child.refreshAbsence();
			}
		});
	}

	public refreshAbsences() {
		this.$children.forEach(c => {
			const child: any = c;
			if (child.refreshAbsence != undefined) {
				child.refreshAbsence();
			}
		});
	}

	public onActualiseListeDocuments(): void {
		this.$children.forEach(c => {
			const child: any = c;
			if (child.actualiseListeDocuments != undefined) {
				child.actualiseListeDocuments();
			}
		});
	}

	public contratHistoriqueUpdated(): void {
		this.$children.forEach(c => {
			const child: any = c;
			// Refresh Qualif
			if (child.refreshQualification != undefined) {
				child.reloadData(this.currentId);
				child.isModified = false;
			}
			// Refresh Identité
			if (child.refreshIdentite != undefined) {
				child.reloadData(this.currentId);
				child.isModified = false;
			}
			// Refresh Competences
			if (child.refreshComptetences != undefined) {
				child.reloadData(this.currentId);
				child.isModified = false;
			}
			// Refresh Declaration
			if (child.refreshDeclaration != undefined) {
				child.reloadData(this.currentId);
				child.isModified = false;
			}
		});
	}

	public qualificationUpdated(): void {
		this.$children.forEach(c => {
			const child: any = c;
			if (child.refreshContrat != undefined) {
				child.refreshContrat();
			}
		});
	}

	public onCounterChanged(value: number): void {
		this.counterNotes = value;
	}
}




// WEBPACK FOOTER //
// ./src/components/ficheSalarie/salarie.ts